<template>
  <footer class="main-container" role="contentinfo">
    <div class="footer-link-container">
      <div class="footer-logos">
        <div class="footer-logo" :class="footerLogoAlignment">
          <img :src="footer.footerLogo" :alt="footer.alt" v-if="footer.footerLogo" />
        </div>
        <ul class="footer-disclaimer-logo__list" v-if="footer.footerLogos.length > 0">
          <li v-for="item in footer.footerLogos" :key="item.title">
            <a :title="item.title" :href="item.url" target="_blank">
              <img :src="item.logo" :alt="item.title" :title="item.title" />
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-links" v-if="footer.footerLinks.length > 0">
        <ul class="footer-disclaimer-links__list1 link-list">
          <li v-for="item in footer.footerLinks" :key="item.title">
            <a :href="item.link" target="_blank">
              {{ item.title }}
            </a>
          </li>
        </ul>
        <div class="disclaimer-content">&copy; {{ footer.footerDisclaimerCopy }}</div>
      </div>
    </div>
  </footer>
</template>
<script>
import SocialMediaIcons from "../atoms/socialMediaIcons.vue";
export default {
  name: "Footer",
  props: {
    footer: Object,
    socials: Array,
  },
  components: { SocialMediaIcons },
  computed: {
    hasSocial() {
      return this.socials.length > 0;
    },

    footerLogoAlignment() {
      let alignment = "";
      switch (this.footer.footerLogoAlignment.toLowerCase()) {
        case "center":
          alignment = "justify-content-center";
          break;
        case "right":
          alignment = "justify-content-end";
          break;
      }
      return alignment;
    },
  },
};
</script>
<style lang="scss" scoped>
footer.main-container {

  padding: 16px 48px;
  color: var(--primaryText);
  background-color: #292929;
  a {
    background-color: transparent;
  }

  @include media-breakpoint-down(md) {
    padding: 0 30px;
  }  
}

.footer-logos {
  display: flex;
  flex-direction: column;
  align-items: center;
  @include media-breakpoint-up(xl) {
    flex-flow: row wrap;
    justify-content: space-between;
  }
  .footer-disclaimer-logo__list {
    display: flex;
    list-style-type: none;
    padding-left: 0;
    margin: 10px 0;
    @include media-breakpoint-up(xl) {
      margin: 0;
    }
    li {
      margin-left: 20px;
      &:first-child {
        margin-left: 30px;
      }
      img {
        opacity: 0.6;
      }       
    }
  }
}

.footer-link-container {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  gap: 16px;
  @include media-breakpoint-up(xl) {
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
  }
  .footer-logos {
    position: relative;
    @include media-breakpoint-up(xl) {
      margin-right: auto;
    }
  }
  .footer-links {
    position: relative;
    @include media-breakpoint-up(xl) {
      margin-left: auto;
    }
    .footer-disclaimer-links__list {
      display: flex;
      flex-flow: row wrap;
      padding: 0;
      margin: 0;
      list-style-type: none;
      color: #e6e7e8;
      justify-content: center;
      @include media-breakpoint-up(md) {
        list-style-type: disc;
      }
      li {
        @include media-breakpoint-up(md) {
          padding-right: 30px;
        }
        &:first-child {
          list-style-type: none;
          a {
            padding-left: 0;
          }
        }
        &:last-child {
          padding-right: 0;
        }
        a {
          color: #f5f5f5;
          text-decoration: none;
          font-size: 12px;
          font-weight: 500;
          margin: 0 5px;
          line-height: 150%;
          @include media-breakpoint-up(xl) {
            // padding-left: 10px;
            margin: 0;
          }
        }
      }
    }

    ul.link-list {
      list-style: none;
      margin: 0;
      padding: 0;

      display: flex;          /* arrange horizontally by default */
      flex-wrap: nowrap;
      align-items: center;    /* vertical centering in the row */
      justify-content: center;
      
    }

    ul.link-list li {
        display: flex;
        align-items: center;    /* ensures bullet aligns with link text */
        color: #F5F5F5;
    }

    /* Separator: a centered dot between items */
    ul.link-list li + li::before {
        content: "•";
        display: inline-block;
        margin: 0 8px;       /* spacing around the dot */       
    }

    ul.link-list a {
      font-size: 12px;      
      text-decoration: none;      
      color: #F5F5F5;
    }   

    @include media-breakpoint-down(md) {
      ul.link-list {
        flex-direction: column;   /* switch to vertical stack */
        align-items: flex-start;
      }
      ul.link-list li + li::before {
        content: none;
      }
      .link-list li {
        margin: 0;
      }
    }
  }
}

.footer-logo {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0px;

  img {
    min-height: 10px;
    max-height: 30px;

    @include media-breakpoint-down(md) {
    }
  }

  h5 {
    font-size: 32px;
    line-height: 150%;
    font-weight: 400;
  }

  &.logo-center {
    justify-content: center;
  }

  &.logo-right {
    justify-content: flex-end;
  }
}

.disclaimer-content {
  font-size: 12px;
  line-height: 150%;
  padding: 0;
  text-align: center;
  color: #a5a5a5;
  margin-top: 8px;
  @include media-breakpoint-up(xl) {
    text-align: right;
  }
  @include media-breakpoint-down(sm) {
    margin-top: 16px;
  }

  ::v-deep * {
    font-family: var(--micrositeTypeStyle) !important;
  }
}

.disclaimer-link {
  margin-top: 10px;
  font-size: 15px;
  line-height: 150%;
  padding-left: 0 !important;

  ::v-deep * {
    font-family: var(--micrositeTypeStyle) !important;
  }
}

.social-icons {
  justify-content: flex-start;
  display: flex;
  column-gap: 24px;
  padding: 24px 0 0 0;

  @include media-breakpoint-up(xl) {
    justify-content: flex-end;
    padding: 0px 0px 0px 24px;
  }
}
@media screen and (max-width: 768px) {
  footer.main-container {
    padding: 16px 24px !important;
  }
  .disclaimer-content {
    text-align: left !important;
    margin-top:16px !important;
    font-size: 12px !important;
  }
 
  .footer-link-container .footer-links .footer-disclaimer-links__list {
    display: flex !important;
    flex-flow: column !important;
  }
  .footer-logos {
    display: flex !important;
    align-items: flex-start !important;
  }
  .footer-logos .footer-disclaimer-logo__list li:first-child {
    margin-left: 0px !important;
  }
  .footer-link-container .footer-links .footer-disclaimer-links__list li a {
    margin: 0px !important;
  }
  ul {
    margin-left: 0px !important;
}
}
</style>
